import jwtAxios from '@tenant/services/auth/jwt-auth';

export const WEBHOOK_REGISTRATION_APIS = {
  ROOT: 'api/app-hooks',
};

export const getListWebhookRegistrationsQuery = (params) => {
  return jwtAxios.get(WEBHOOK_REGISTRATION_APIS.ROOT, { params });
};

export const getDetailWebhookRegistrationQuery = (id) => {
  return jwtAxios.get(`${WEBHOOK_REGISTRATION_APIS.ROOT}/${id}`);
};

export const createWebhookRegistrationQuery = (payload) => {
  return jwtAxios.post(WEBHOOK_REGISTRATION_APIS.ROOT, payload);
};

export const updateWebhookRegistrationQuery = ({ id, ...payload }) => {
  return jwtAxios.patch(`${WEBHOOK_REGISTRATION_APIS.ROOT}/${id}`, payload);
};

export const disableWebhookRegistrationQuery = (id) => {
  return jwtAxios.patch(`${WEBHOOK_REGISTRATION_APIS.ROOT}/${id}/disable`);
};

export const enableWebhookRegistrationQuery = (id) => {
  return jwtAxios.patch(`${WEBHOOK_REGISTRATION_APIS.ROOT}/${id}/enable`);
};

export const getFailedCallbacksQuery = (id, params) => {
  return jwtAxios.get(`${WEBHOOK_REGISTRATION_APIS.ROOT}/${id}/failed-callbacks`, { params });
};
